const API = {
    LOGIN: 'login',
    ME: 'me',
    FORGET_PASSWORD: 'forgot-password',
    VERIFY_OTP: 'verify-otp',
    RESEND_OTP: 'resend-otp',
    RESET_PASSWORD: 'reset-password',
    PROJECT_LIST: 'project/list?',
    PROJECT_OPTION_LIST: 'get/project/list',
    PROJECT_DELETE: 'project/delete',
    PROJECT_CREATE: 'project/create',
    PROJECT_UPDATE: 'project/update',
    PROJECT_UNITS_LIST: 'project/units/list?',
    PROJECT_UNIT_DELETE: 'project/unit/delete/',
    PROJECT_UNIT_CREATE: 'project/unit/create',
    PROJECT_UNIT_UPDATE: 'project/unit/update',
    BOOKING_LIST: 'booking/list?',
    BOOKING_DELETE: 'booking/delete',
    BOOKING_CREATE: 'booking/create',
    BOOKING_UPDATE: 'booking/update',
    PERMISSIONS: 'get-permissions',
    ALL_AGENT_LIST: 'all-agent/list',
    AGENT_LIST: 'agent/list',
    SUPPLIERS_LIST: 'supplier/pagination/list',
    UNIT_LIST: 'unit/pagination/list',
    STOCK_LIST: 'stock/pagination/list',
    INVENTORY_LIST: "inventory/pagination/list",
    ROYALTY_LIST: "royalty/pagination/list",
    AGENT_COMMISSION_REPORT: "agent-commission/report",
    LOAN_LIST: "loan/pagination/list",
    DAY_BOOK_LIST: "day-book/pagination/list",
};

export default API;